<template>
	<b-modal ref="modal" size="lg" hide-footer>
		<template v-slot:modal-title>
			{{ $t('invoice.supplier_article_aliases_title', { label }) }}
		</template>

		<LoadingSpinner v-if="loading" />

		<div v-else-if="!aliases.length" class="alert alert-info mb-0">
			{{ $t('invoice.supplier_article_aliases_empty') }}
		</div>

		<template v-else>
			<p class="text-muted">{{ $t('invoice.supplier_article_aliases_help') }}</p>

			<table class="table table-sm mb-0">
				<thead>
					<tr>
						<th>{{ $t('invoice.supplier_article_aliases_label') }}</th>
						<th>{{ $t('invoice.supplier_article_aliases_date') }}</th>
						<th></th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="alias in aliases" :key="alias.isaliases_id">
						<td>{{ alias.isaliases_label }}</td>
						<td>{{ formatDate(alias.isaliases_inserted) }}</td>
						<td class="text-right">
							<button class="btn btn-sm btn-secondary" :disabled="unlinking !== null" @click="unlink(alias)">
								<font-awesome-icon v-if="unlinking === alias.isaliases_id" :icon="['fas', 'spinner']" pulse />
								{{ $t('invoice.supplier_article_aliases_unlink') }}
							</button>
						</td>
					</tr>
				</tbody>
			</table>
		</template>
	</b-modal>
</template>

<script type="text/javascript">
	import Invoice from "@/mixins/Invoice.js"

	export default {
		name: "ArticleAliasesModal",
		mixins: [Invoice],
		data() {
			return {
				tiers_id: null,
				label: '',
				aliases: [],
				loading: false,
				// Alias en cours de déliage : un seul à la fois, les lignes qu'il rend repassent par le
				// rapprochement du serveur.
				unlinking: null
			}
		},
		methods: {
			/**
			 * Ouvre la modale sur les libellés rangés sous un article du fournisseur.
			 *
			 * @param {Object} article Article du tableau des articles achetés.
			 * @param {Number} tiers_id Fournisseur de l'article.
			 */
			async open(article, tiers_id) {
				this.tiers_id = tiers_id
				this.label = article.isarticles_label
				this.aliases = []
				this.unlinking = null
				this.loading = true
				this.$refs.modal.show()

				this.aliases = await this.getTiersSupplierArticleAliases(tiers_id, article.isarticles_id) || []
				this.loading = false
			},

			/**
			 * Délie un libellé : les lignes qu'il rangeait sous l'article retrouvent celui de leur propre
			 * libellé, et l'onglet est prévenu que sa liste a changé.
			 *
			 * @param {Object} alias
			 */
			async unlink(alias) {
				this.unlinking = alias.isaliases_id

				if(await this.unlinkTiersSupplierArticleAlias(this.tiers_id, alias.isaliases_id)) {
					this.aliases = this.aliases.filter(other => other.isaliases_id !== alias.isaliases_id)
					this.$emit('updated')
				}

				this.unlinking = null
			}
		}
	}
</script>
